import React from 'react'

import Reflux from 'reflux-react-16'
import _ from 'lodash'

import {Alert, Badge, Button, Card, Divider, H3, H6, P, Panel, Row, ToolTip} from '../../../../components/UI/index.js'
import {formSpacing, FormRow, Input, Toggle} from '../../../../components/UI/forms/index.js'
import CarrierModal from '../../../../components/resellers/CarrierModal.js'
import LoginActions from '../../../../actions/LoginActions.js'
import ParcelActions from '../../../../actions/ParcelActions.js'
import {updateCarrierSettingProducts} from '@utils/carrierSettingProducts.js'
import t from 'src/helpers/Languages.js'

class ParcelCarriers extends Reflux.Component {
    constructor(props) {
        super(props)

        this.state = {carrier: props.reseller.name, partnerKey: '', partnerError: '', showCopyTooltip: false}
    }

    async onClickCopyPartnerKey() {
        if (navigator && navigator.clipboard) {
            try {
                await navigator.clipboard.writeText(this.props.reseller.settings.partnerKey)

                clearTimeout(this.tooltipTimeout)

                this.setState({showCopyTooltip: true})

                this.tooltipTimeout = setTimeout(() => this.setState({showCopyTooltip: false}), 2000)
            } catch (err) {
                console.log(err)
            }
        }
    }

    onClickAddPartner() {
        LoginActions.addParcelPartner(this.state.partnerKey, (err) => {
            this.setState({partnerKey: '', partnerError: err || ''})

            if (!err) {
                ParcelActions.getCarriers()
            }
        })
    }

    onChangeCarrierSettings(carrierName, settings) {
        const {reseller, onChange} = this.props
        reseller.settings.parcels.carriers[carrierName] = {...settings}
        onChange(reseller, ['parcels', 'carriers', carrierName])

        reseller.settings.parcels.products = reseller.settings.parcels.products || {}

        if (updateCarrierSettingProducts(reseller.settings.parcels.products, carrierName, settings).length > 0) {
            onChange(reseller, 'parcels.products')
        }
    }

    onEnablePartner() {
        const {reseller, onChange} = this.props

        reseller.settings.parcels.carriers.isVeloydPartner = !reseller.settings.parcels.carriers.isVeloydPartner

        onChange(reseller, 'parcels.carriers.isVeloydPartner')
    }

    onSendAcceptPartner(partner) {
        const {reseller, onChange} = this.props

        reseller.settings.parcels.carriers.partners = reseller.settings.parcels.carriers.partners || []

        const index = reseller.settings.parcels.carriers.partners.indexOf(partner)

        if (index === -1) {
            reseller.settings.parcels.carriers.partners.push(partner)
        } else {
            reseller.settings.parcels.carriers.partners.splice(index, 1)
        }

        onChange(reseller, 'parcels.carriers.partners')

        // A partner without connection can no longer be deactivated, so deactivate it when the connection is broken
        const settings = reseller.settings.parcels.carriers[partner]
        if (index !== -1 && settings?.enabled) {
            this.onChangeCarrierSettings(partner, {...settings, enabled: false})
        }

        setTimeout(() => ParcelActions.getCarriers(), 500)
    }

    render() {
        const {reseller} = this.props

        const [onlineParcelCarriers, carriers] = _.partition(this.props.carriers, (carrier) => carrier.platform === 'Onlineparcel')

        return (
            <>
                <Card shadow style={{padding: 24, width: 1173, height: 'fit-content'}}>
                    <H3 style={{marginBottom: 36}}>{t('carriers')}</H3>

                    <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: 24}}>
                        {carriers.map((carrier) => {
                            // Also show enabled partners without connection, so they can still be deactivated
                            if (carrier.type !== 'partner' || (reseller.settings.parcels.carriers.partners.indexOf(carrier.name) > -1) && carrier.isPartner || reseller.settings.parcels.carriers[carrier.name]?.enabled) {
                                const settings = reseller.settings.parcels.carriers[carrier.name] ? JSON.parse(JSON.stringify(reseller.settings.parcels.carriers[carrier.name])) : {}

                                if (settings.enabled) {
                                    return (
                                        <Card style={{margin: 12, padding: 12, width: 350}} key={carrier.name}>
                                            <div style={{display: 'flex', alignItems: 'center', marginBottom: 24}}>
                                                <img style={{marginRight: 24, objectFit: 'contain'}} src={carrier.logo} width={64} height={64} />

                                                <H6 style={{marginBottom: 12}}>{carrier.displayName}{carrier.platform ? ` - ${carrier.platform}` : ''}</H6>
                                            </div>

                                            <br />
                                            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                                                {reseller.settings.parcels.carriers[carrier.name] && reseller.settings.parcels.carriers[carrier.name].enabled ?
                                                    <Button variant='text' onClick={() => this.carrierModal.open(carrier.name, settings)}>{t('settings')}</Button> :
                                                    <Button onClick={() => this.carrierModal.open(carrier.name, settings)}>{t('activate')}</Button>
                                                }
                                            </div>
                                        </Card>
                                    )
                                }
                            }
                        })}
                    </div>

                    <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: 36}}>
                        {carriers.map((carrier) => {
                            if (carrier.name === 'PostNL-MSG' && !reseller.msgPostNLenabled) {
                                return
                            }

                            if (carrier.name === 'DHL-MSG' && !reseller.msgDHLenabled) {
                                return
                            }

                            if (carrier.name.includes('QLS') && !reseller.qlsEnabled) {
                                return
                            }

                            if (carrier.name === 'Intrapost' && !reseller.intrapostEnabled) {
                                return
                            }

                            if (carrier.type !== 'partner' || (reseller.settings.parcels.carriers.partners.indexOf(carrier.name) > -1) && carrier.isPartner) {
                                const settings = reseller.settings.parcels.carriers[carrier.name] ? JSON.parse(JSON.stringify(reseller.settings.parcels.carriers[carrier.name])) : {}

                                if (!settings.enabled) {
                                    return (
                                        <Card style={{margin: 12, padding: 12, width: 350}} key={carrier.name}>
                                            <div style={{display: 'flex', alignItems: 'center', marginBottom: 36}}>
                                                <img style={{marginRight: 24, objectFit: 'contain'}} src={carrier.logo} width={64} height={64} />

                                                <H6 style={{marginBottom: 12}}>{carrier.displayName}{carrier.platform ? ` - ${carrier.platform}` : ''}</H6>
                                            </div>

                                            <br />
                                            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                                                {reseller.settings.parcels.carriers[carrier.name] && reseller.settings.parcels.carriers[carrier.name].enabled ?
                                                    <Button variant='text' onClick={() => this.carrierModal.open(carrier.name, settings)}>{t('settings')}</Button> :
                                                    <Button onClick={() => this.carrierModal.open(carrier.name, settings)}>{t('activate')}</Button>
                                                }
                                            </div>
                                        </Card>
                                    )
                                }
                            }
                        })}
                    </div>

                    <H6 style={{marginBottom: 12}}>{reseller.customBrandingEnabled ? t('partnerCarriersCustomBranding') : t('veloydPartnerCarriers')}</H6>
                    <Divider style={{marginBottom: 12}} />
                    <P>{t('partnerCarriersInfo')}</P>
                    <br />

                    <Toggle
                        style={{width: 500}}
                        label={t('visibleAsPartnerCarrier')}
                        checked={reseller.settings.parcels.carriers.isVeloydPartner}
                        onChange={this.onEnablePartner.bind(this)}
                    />

                    {reseller.settings.parcels.carriers.isVeloydPartner &&
                        <>
                            <FormRow style={{alignItems: 'center', marginTop: formSpacing.section, marginBottom: formSpacing.rowGap, width: 500}}>
                                <Input
                                    style={{flex: 1}}
                                    label={t('partnerOwnKeyTitle')}
                                    value={reseller.settings.partnerKey}
                                    readOnly
                                />

                                <Button variant='outline-white' onClick={() => this.onClickCopyPartnerKey()}>
                                    <i className='mdi mdi-content-copy' />
                                </Button>
                            </FormRow>

                            <ToolTip visible={this.state.showCopyTooltip} text={t('copiedToClipboard')}></ToolTip>

                            <FormRow style={{alignItems: 'center', marginBottom: formSpacing.rowGap, width: 500}}>
                                <Input
                                    style={{flex: 1}}
                                    label={t('partnerAddByApiKey')}
                                    value={this.state.partnerKey}
                                    onChange={(event) => this.setState({partnerKey: event.target.value})}
                                />

                                <Button
                                    variant='outline-white'
                                    disabled={!this.state.partnerKey}
                                    onClick={this.onClickAddPartner.bind(this)}
                                >
                                    {t('partnerSendRequest')}
                                </Button>
                            </FormRow>

                            {this.state.partnerError &&
                                <Alert variant='danger' style={{width: 500, marginBottom: 12}}>{this.state.partnerError}</Alert>
                            }

                            <br />

                            {carriers.map((carrier) => {
                                if (carrier.type === 'partner') {
                                    const checked = reseller.settings.parcels.carriers.partners.indexOf(carrier.name) > -1

                                    // An enabled partner without connection is only listed above to deactivate it, a new connection is made with the partner's API key
                                    if (!checked && !carrier.isPartner) {
                                        return null
                                    }

                                    return (
                                        <div
                                            key={carrier.name}
                                            style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: 500}}
                                        >
                                            <P>{carrier.displayName}{carrier.platform ? ` - ${carrier.platform}` : ''}</P>
                                            {checked &&
                                                <>
                                                    <Badge variant={carrier.isPartner ? 'success' : 'info'}>
                                                        {carrier.isPartner ?
                                                            t('partnerConnectionActive') :
                                                            t('partnerRequestSent')
                                                        }
                                                    </Badge>
                                                    <Button
                                                        variant='text'
                                                        onClick={this.onSendAcceptPartner.bind(this, carrier.name)}
                                                    >
                                                        {t('deactivate')}
                                                    </Button>
                                                </>
                                            }

                                            {!checked && carrier.isPartner &&
                                                <>
                                                    <Badge variant='info'>
                                                        {t('partnerRequestReceived')}
                                                    </Badge>
                                                    <Button
                                                        variant='text'
                                                        onClick={this.onSendAcceptPartner.bind(this, carrier.name)}
                                                    >
                                                        {t('accept')}
                                                    </Button>
                                                </>
                                            }

                                        </div>
                                    )
                                }
                            })}

                            <br />
                        </>
                    }

                    <CarrierModal
                        ref={(ref) => this.carrierModal = ref}
                        reseller={reseller}
                        carriers={this.props.carriers}
                        onSubmit={this.onChangeCarrierSettings.bind(this)}
                    />
                </Card>
                {/* No onlineparcel for non Business Post Hoogeveen (Stark) and Veloyd resellers */}
                {(reseller.name === 'Stark' || reseller.name === 'Veloyd') &&
                    <Panel style={{marginTop: 36, padding: 20, width: 1165}}>
                        <H3 style={{marginBottom: 36}}>{t('carriersViaPlatform')}</H3>

                        <P>{t('carriersViaPlatformInfo')}</P>
                        <Card style={{margin: 12, padding: '12px 24px', width: 350}}>
                            <Row style={{justifyContent: 'space-evenly', gap: 12}}>

                                {onlineParcelCarriers.map((carrier) => (
                                    <div style={{textAlign: 'center'}} key={carrier.name}>
                                        <img style={{objectFit: 'contain', ...(!reseller.settings.parcels.carriers[carrier.name]?.enabled && {filter: 'grayscale(100%)'})}} src={carrier.logo} width={48} height={48} />
                                        <P>{carrier.displayName}</P>
                                    </div>
                                ))}
                            </Row>

                            <Divider style={{marginBottom: 12, marginTop: 12}} />

                            <H6 style={{marginBottom: 12}}>{t('platform')}</H6>

                            <Row style={{gap: 24, alignItems: 'center'}}>
                                <img src='/images/onlineparcel.png' style={{objectFit: 'contain'}} width={64} height={64} />
                                <P>Onlineparcel.nl</P>
                            </Row>
                            <Row style={{justifyContent: 'flex-end'}}>
                                <Button
                                    onClick={() => {
                                        const firstCarrier = onlineParcelCarriers[0]
                                        const firstCarrierSettings = reseller.settings.parcels.carriers[firstCarrier.name] ? structuredClone(reseller.settings.parcels.carriers[firstCarrier.name]) : {}
                                        this.carrierModal.open(firstCarrier.name, firstCarrierSettings, onlineParcelCarriers, 'Onlineparcel')
                                    }}
                                    variant='text'
                                >
                                    {t('settings')}
                                </Button>
                            </Row>
                        </Card>
                    </Panel>
                }
            </>
        )
    }
}

export default (ParcelCarriers)
